// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.tab-container {
  padding: 24px;
  background-color: #f4f6f8;
  position: relative;
  margin-top: 10px;
}
.tab-container .global-upload-notification {
  margin-bottom: 16px;
  animation: slideDown 0.3s ease-out;
}
.tab-container .global-upload-notification .upload-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}
.tab-container .global-upload-notification .upload-banner .upload-banner-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.tab-container .global-upload-notification .upload-banner .upload-banner-left .upload-icon {
  font-size: 20px;
  animation: bounce 2s infinite;
}
.tab-container .global-upload-notification .upload-banner .upload-banner-left .upload-text {
  font-size: 14px;
  font-weight: 500;
}
.tab-container .global-upload-notification .upload-banner .upload-banner-right {
  display: flex;
  gap: 8px;
}
.tab-container .global-upload-notification .upload-banner .upload-banner-right button {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.tab-container .global-upload-notification .upload-banner .upload-banner-right button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}
.tab-container .global-upload-notification .upload-banner .upload-banner-right button.view-uploads-btn {
  background: white;
  color: #667eea;
  border-color: white;
}
.tab-container .global-upload-notification .upload-banner .upload-banner-right button.view-uploads-btn:hover {
  background: rgba(255, 255, 255, 0.95);
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
.tab-container .tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.tab-container .tab-header .info-button {
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--primary-color, #007bff);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 15;
}
.tab-container .tab-header .info-button:hover {
  background-color: var(--primary-color-dark, #0056b3);
  transform: scale(1.1);
}
.tab-container .tab-header .info-button:hover .info-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.tab-container .tab-header .info-button .info-tooltip {
  position: absolute;
  bottom: 35px;
  right: 0;
  background: white;
  color: #333;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 13px;
  line-height: 1.4;
  width: 280px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
  border: 1px solid #e0e0e0;
}
.tab-container .tab-header .info-button .info-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 12px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid white;
}
.tab-container .tab-header .info-button .info-tooltip::before {
  content: "";
  position: absolute;
  top: 100%;
  right: 11px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #e0e0e0;
  z-index: -1;
}
.tab-container .tab-buttons-with-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
  background-color: inherit;
  position: sticky;
  top: 0;
  padding: 12px 0;
  z-index: 10;
}
.tab-container .tab-buttons-with-info .tab-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
}
.tab-container .tab-buttons-with-info .tab-buttons button {
  padding: 8px 14px;
  background: #f1f1f1;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;
  border: none;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: flex-start;
}
.tab-container .tab-buttons-with-info .tab-buttons button .tab-bubble {
  background-color: crimson;
  color: white;
  font-size: 11px;
  font-weight: bold;
  border-radius: 10px;
  padding: 2px 6px;
  margin-left: 6px;
  animation: popIn 0.3s ease-in-out;
}
@keyframes popIn {
  from {
    transform: scale(0.7);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.tab-container .tab-buttons-with-info .tab-buttons button.active {
  border-bottom: 2px solid var(--primary-border-color);
  font-weight: bold;
  color: var(--primary-color);
  background-color: white;
}
.tab-container .tab-buttons-with-info .tab-buttons button:not(.active):hover {
  background-color: #e0e0e0;
}
.tab-container .tab-buttons-with-info .tab-info-container {
  margin-left: auto;
  padding-left: 20px;
  display: flex;
  align-items: center;
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button {
  position: relative;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary-color, #007bff) 0%, #0056b3 100%);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 15;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004494 100%);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button:hover .info-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button:active {
  transform: scale(0.95);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {
  position: absolute;
  bottom: 35px;
  right: 0;
  background: white;
  color: #333;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 13px;
  line-height: 1.4;
  width: 320px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
  border: 1px solid #e0e0e0;
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 12px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid white;
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip::before {
  content: "";
  position: absolute;
  top: 100%;
  right: 11px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #e0e0e0;
  z-index: -1;
}
.tab-container .tab-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding-right: 8px;
  background-color: inherit;
  margin-top: 12px;
  overflow-y: auto;
  border-radius: 8px;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}
.tab-container .tab-content::-webkit-scrollbar {
  width: 6px;
}
.tab-container .tab-content::-webkit-scrollbar-thumb {
  background-color: #bbb;
  border-radius: 4px;
}
.tab-container .tab-content .summary {
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.tab-container .tab-content .summary .sum-amount {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tab-container .tab-content .summary .tab-add {
  display: flex;
  justify-content: end;
}
.tab-container .tab-content .summary .tab-add > button {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.tab-container .tab-content .summary .tab-add > button:hover {
  background: #0052a3;
}
.tab-container .order-card-doc {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  border-left: 4px solid var(--primary-border-color);
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.tab-container .order-card-doc .doc-content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}
.tab-container .order-card-doc .tab-add {
  justify-content: end;
}
.tab-container .order-card-doc .tab-add .view-doc-cases {
  padding: 0.5rem 0.75rem;
  border-radius: 10px;
  border: 1px solid #ddd;
  color: var(--primary-color);
  background-color: #fff;
  cursor: pointer;
}
.tab-container .order-card-doc .tab-add .view-doc-cases:hover {
  background-color: var(--primary-color);
  color: #fff;
}
.tab-container .order-card-doc .customer-doc-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
  justify-content: flex-start;
  margin-top: 0;
  flex-shrink: 0;
}
.tab-container .order-card-doc .customer-doc-actions .upload-btn-add-docs,
.tab-container .order-card-doc .customer-doc-actions .view-doc-cases {
  padding: 0.5rem 0.75rem;
  border-radius: 10px;
  border: 1px solid #ddd;
  color: var(--primary-color);
  background-color: #fff;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.tab-container .order-card-doc .customer-doc-actions .upload-btn-add-docs:hover,
.tab-container .order-card-doc .customer-doc-actions .view-doc-cases:hover {
  background-color: var(--primary-color);
  color: #fff;
  border-color: var(--primary-color);
}
.tab-container .order-card-doc .customer-doc-actions .upload-btn-add-docs:hover {
  background-color: var(--primary-color);
  color: #fff;
}
.tab-container .order-card-doc:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.tab-container .order-card-doc p {
  margin: 6px 0;
  font-size: 15px;
  color: #333;
}
.tab-container .order-card-doc p strong {
  color: #1a1a1a;
}
.tab-container .order-card-doc a {
  display: inline-block;
  color: var(--primary-color);
  font-weight: 500;
  text-decoration: none;
}
.tab-container .order-card-doc a:hover {
  text-decoration: underline;
}
.tab-container .order-card-doc .editdel {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
}
.tab-container .order-card-doc .editdel > button {
  color: var(--text-color);
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  width: 150px;
}
.tab-container .order-card-doc .editdel .editbtn {
  background-color: rgba(27, 42, 78, 0.8);
}
.tab-container .order-card-doc .editdel .editbtn:hover {
  background-color: rgba(27, 42, 78, 0.9);
}
.tab-container .order-card-doc .editdel .delbtn {
  background-color: rgba(239, 107, 110, 0.9);
}
.tab-container .order-card-doc .editdel .delbtn:hover {
  background-color: rgb(239, 107, 110);
}
.tab-container .order-card-doc .doc-div-detail {
  display: flex;
  justify-content: space-between;
  width: 70%;
}
.tab-container .order-card-doc .doc-div-detail div {
  width: 50%;
}
.tab-container .additional-doc-cards {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
}
.tab-container .additional-doc-cards .doc-status-badge {
  background-color: darkgreen;
  position: absolute;
  top: 0px;
  right: 0;
  padding: 4px 10px 4px 16px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.tab-container .additional-doc-cards .doc-status-badge::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.tab-container .order-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px var(--boxshadow-color);
  border-left: 4px solid var(--primary-border-color);
  transition: box-shadow 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.tab-container .order-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.tab-container .order-card p {
  margin: 6px 0;
  font-size: 15px;
  color: #333;
}
.tab-container .order-card p strong {
  color: #1a1a1a;
}
.tab-container .order-card a {
  display: inline-block;
  color: var(--primary-color);
  font-weight: 500;
  text-decoration: none;
}
.tab-container .order-card a:hover {
  text-decoration: underline;
}
.tab-container .order-card .editdel {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
}
.tab-container .order-card .editdel > button {
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  width: 50px;
}
.tab-container .order-card .note-div-detail,
.tab-container .order-card .order-expense-card,
.tab-container .order-card .task-div-detail {
  display: flex;
  justify-content: space-between;
  width: 70%;
}
.tab-container .order-card .note-div-detail div,
.tab-container .order-card .order-expense-card div,
.tab-container .order-card .task-div-detail div {
  width: 50%;
}
.tab-container .order-card .order-det-card {
  width: 70%;
  display: flex;
  justify-content: space-between;
}
.tab-container .order-card .order-det-card .ord-det-card1 {
  width: 60%;
}
.tab-container .order-card .order-det-card .ord-det-card2 {
  width: 30%;
}
.tab-container .task-badge {
  position: absolute;
  top: 0px;
  right: 0;
  padding: 4px 10px 4px 16px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.tab-container .task-badge::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.tab-container .task-badge.new {
  background-color: darkgreen;
}
.tab-container .task-badge.updated {
  background-color: darkcyan;
}
.tab-container .simple-item {
  background-color: var(--primary-background-color);
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 1px 4px var(--boxshadow-color);
  border-left: 3px solid #8884d8;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  color: #444;
}
.tab-container .simple-item:last-child {
  margin-bottom: 0;
}
.tab-container .pagination {
  display: none;
}
.tab-container a {
  color: var(--primary-color);
  text-decoration: none;
}
.tab-container a:hover {
  text-decoration: underline;
}
.tab-container .modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  z-index: 1000;
}
.tab-container .modal-backdrop .modal {
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 8px;
  background-color: white;
  width: 100%;
  max-width: 600px;
}
.tab-container .modal-backdrop .modal h2 {
  margin-top: 0;
  font-size: 1.2rem;
  margin-bottom: 16px;
}
.tab-container .modal-backdrop .modal form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.tab-container .modal-backdrop .modal form label {
  font-weight: 500;
}
.tab-container .modal-backdrop .modal form input,
.tab-container .modal-backdrop .modal form textarea,
.tab-container .modal-backdrop .modal form select {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  resize: vertical;
  font-family: inherit;
}
.tab-container .modal-backdrop .modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.tab-container .modal-backdrop .modal .modal-actions button {
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}
.tab-container .modal-backdrop .modal .modal-actions button[type=submit] {
  background-color: #28a745;
  color: #fff;
}
.tab-container .modal-backdrop .modal .modal-actions button[type=submit]:hover {
  background-color: #218838;
}
.tab-container .modal-backdrop .modal .modal-actions button[type=button] {
  background-color: #6c757d;
  color: #fff;
}
.tab-container .modal-backdrop .modal .modal-actions button[type=button]:hover {
  background-color: #5a6268;
}
.tab-container .modal-backdrop .modal .task-tab-switcher {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn {
  flex: 1 1;
  padding: 0.5rem 1rem;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  cursor: pointer;
  font-weight: 500;
  color: #374151;
  transition: all 0.2s ease;
}
.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn:hover {
  background-color: #e5e7eb;
}
.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn.active {
  background-color: #2563eb;
  color: white;
  border-color: #2563eb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.tab-container .modal-backdrop .modal .assigned-due {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.5rem;
}
@media (min-width: 400px) {
  .tab-container .modal-backdrop .modal .assigned-due .assignedto {
    width: 48%;
  }
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .dropdown-container {
  margin-bottom: 0.5rem;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .dropdown-container .selectInput {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag {
  background-color: #e0f2f7;
  color: #0d47a1;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag span {
  margin-right: 0.3rem;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag .remove-assignee {
  background: none;
  border: none;
  color: #d32f2f;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 0;
  line-height: 1;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag .remove-assignee:hover {
  color: #c62828;
}
.tab-container .timeline-container {
  position: relative;
  margin: 20px;
  padding: 15px 0;
  border-left: 4px solid #d0d0d0;
}
.tab-container .timeline-container.no-timeline-data {
  position: relative;
  margin: 0px;
  padding: 0px;
  border-left: none;
}
.tab-container .timeline-container .timeline-item {
  position: relative;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}
.tab-container .timeline-container .timeline-item .timeline-dot {
  position: absolute;
  left: -9px;
  top: 5px;
  width: 15px;
  height: 15px;
  background-color: #3a86ff;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 0 10px rgba(58, 134, 255, 0.4);
  cursor: pointer;
  transition: transform 0.3s ease;
}
.tab-container .timeline-container .timeline-item .timeline-dot:hover {
  transform: scale(1);
  z-index: 10000;
}
.tab-container .timeline-container .timeline-item .timeline-dot:hover .tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  z-index: 10001;
}
.tab-container .timeline-container .timeline-item .timeline-dot.dot-disposed {
  background-color: #999;
  box-shadow: 0 0 10px rgba(150, 150, 150, 0.4);
}
.tab-container .timeline-container .timeline-item .timeline-dot .tooltip {
  position: absolute;
  top: -40px;
  left: 25px;
  background: #fff;
  border-left: 4px solid var(--primary-color);
  color: #333;
  padding: 14px;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  min-width: 480px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 9999;
  white-space: normal;
}
.tab-container .timeline-container .timeline-item .timeline-dot .tooltip div {
  margin-bottom: 6px;
}
.tab-container .timeline-container .timeline-item .timeline-content {
  margin-left: 20px;
  padding: 14px 18px;
  background-color: #fff;
  border-radius: 10px;
  font-size: 15px;
  color: #444;
}
.tab-container .timeline-container .timeline-item .timeline-content p {
  margin: 0;
}

.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  border: 2px dashed #cbd5e1;
  min-height: 200px;
  position: relative;
  overflow: hidden;
}
@keyframes subtle-pulse {
  0%, 100% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}
.no-data-container .no-data-title {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 2;
}
.no-data-container .no-data-message {
  font-size: 1rem;
  color: #6b7280;
  max-width: 400px;
  line-height: 1.5;
  position: relative;
  z-index: 2;
}
@media (max-width: 768px) {
  .no-data-container {
    padding: 2rem 1rem;
    min-height: 160px;
  }
  .no-data-container .no-data-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 1rem;
  }
  .no-data-container .no-data-title {
    font-size: 1.25rem;
  }
}

.tab-content {
  background-color: #f9f9f9;
}
.tab-content .table-responsive {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 10px;
}
.tab-content .table-responsive::-webkit-scrollbar {
  height: 6px;
}
.tab-content .table-responsive::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}
.tab-content .documents-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--card-bg, #ffffff);
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px var(--shadow-light, rgba(0, 0, 0, 0.05));
}
.tab-content .documents-table thead {
  background-color: #f1f5f9;
}
.tab-content .documents-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
  font-weight: 600;
  border-bottom: 1px solid var(--border-color, #e2e8f0);
  white-space: nowrap;
}
.tab-content .documents-table tbody tr {
  transition: background-color 0.2s ease;
}
.tab-content .documents-table tbody tr:hover {
  background-color: #f9fafb;
}
.tab-content .documents-table tbody tr:not(:last-child) td {
  border-bottom: 1px solid var(--border-color, #f1f5f9);
}
.tab-content .documents-table tbody tr td {
  padding: 0.9rem 1rem;
  color: #374151;
  vertical-align: middle;
}

.td-th-casedet {
  font-size: 14px;
}

.order-card-doc {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  background-color: #fff;
}

.doc-div-detail {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.added-docs-task-upload-section {
  border: 1px dashed #0066cc;
  padding: 10px;
  border-radius: 5px;
}

.added-docs-task-upload-label {
  font-weight: bold;
}

.added-docs-task-upload-click-area {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.added-docs-task-upload-icon {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.added-docs-task-upload-progress {
  margin: 10px 0;
}

.added-docs-task-upload-progress-bar {
  margin-bottom: 10px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
}

.added-docs-task-upload-progress-indicator {
  background-color: #0066cc;
  height: 10px;
}

.added-docs-task-uploaded-file {
  margin-top: 10px;
}

.added-docs-task-upload-cancel-button,
.added-docs-task-upload-submit-button {
  margin-right: 10px;
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}

.act-upload-btns {
  display: flex;
  gap: 0.5rem;
  margin-top: 10px;
}
.act-upload-btns .added-docs-task-upload-cancel-button,
.act-upload-btns .added-docs-task-upload-submit-button {
  margin-right: 10px;
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}
.act-upload-btns .added-docs-task-upload-submit-button {
  background-color: #28a745;
}

.added-docs-task-upload-button-container {
  margin-top: 10px;
}
.added-docs-task-upload-button-container .upload-btn-add-docs {
  padding: 0.5rem 0.75rem;
  border-radius: 10px;
  border: 1px solid #ddd;
  color: var(--primary-color);
  background-color: #fff;
  cursor: pointer;
}
.added-docs-task-upload-button-container .upload-btn-add-docs:hover {
  background-color: var(--primary-color);
  color: #fff;
}

.header-actions-container {
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

.actions-right {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}
.actions-right .view-toggles {
  display: flex;
  gap: 4px;
}
.actions-right .view-toggles .toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.actions-right .view-toggles .toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.actions-right .view-toggles .toggle-btn:hover {
  background-color: #f3f4f6;
}
.actions-right .view-toggles .toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}

.grid-view-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.editdel-table-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.editdel-table-actions button {
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  width: 50px;
}
/* --- Modern Grid View Styles (Only affects Grid Mode) --- */
.orders-grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 10px 2px;
}
.orders-grid-layout .modern-order-card {
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.orders-grid-layout .modern-order-card .card-header-strip {
  background-color: #f8f9fa;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease;
}
.orders-grid-layout .modern-order-card .card-header-strip .order-badge {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--primary-color, #007bff);
  display: flex;
  align-items: center;
  gap: 6px;
}
.orders-grid-layout .modern-order-card .card-header-strip .order-date {
  font-size: 0.85rem;
  color: #666;
  font-weight: 500;
}
.orders-grid-layout .modern-order-card .card-content-body {
  padding: 16px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.orders-grid-layout .modern-order-card .card-content-body .detail-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.orders-grid-layout .modern-order-card .card-content-body .detail-row .detail-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.orders-grid-layout .modern-order-card .card-content-body .detail-row .detail-label .row-icon {
  font-size: 0.9rem;
  color: #aaa;
}
.orders-grid-layout .modern-order-card .card-content-body .detail-row .detail-value {
  font-size: 0.95rem;
  color: #333;
  font-weight: 500;
  padding-left: 2px;
  line-height: 1.4;
}
.orders-grid-layout .modern-order-card .card-content-body .detail-row .detail-value.judge-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.orders-grid-layout .modern-order-card .card-footer-action {
  padding: 10px 12px;
  border-top: 1px solid #f0f0f0;
  background-color: #fff;
  /* Flexbox Layout */
  display: flex;
  align-items: stretch; /* vital: makes both buttons same height if one wraps */
  justify-content: space-between;
  gap: 8px;
  /* Shared styles for both buttons/boxes */
  /* Specific styles for Upload Button */
}
.orders-grid-layout .modern-order-card .card-footer-action .pdf-btn,
.orders-grid-layout .modern-order-card .card-footer-action .no-doc-status,
.orders-grid-layout .modern-order-card .card-footer-action > button,
.orders-grid-layout .modern-order-card .card-footer-action .upload-btn,
.orders-grid-layout .modern-order-card .card-footer-action .view-uploads-btn {
  flex: 1 1;
  min-width: 0;
  /* FIX FOR TEXT CUTTING: */
  white-space: normal;
  text-align: center;
  line-height: 1.2;
  font-size: 0.75rem;
  padding: 6px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  height: auto; /* Allows height to grow with text */
}
.orders-grid-layout .modern-order-card .card-footer-action .pdf-btn {
  border: 1px solid var(--primary-color, #007bff);
  background-color: rgba(0, 123, 255, 0.05);
  color: var(--primary-color, #007bff);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.orders-grid-layout .modern-order-card .card-footer-action .pdf-btn:hover {
  background-color: var(--primary-color, #007bff);
  color: white;
}
.orders-grid-layout .modern-order-card .card-footer-action .no-doc-status {
  color: #dc3545;
  background-color: #fff5f5;
  border: 1px solid #dc3545;
  font-weight: 600;
  font-size: 0.7rem; /* Make the error text slightly smaller */
}

/* --- Modern Document Grid View Styles --- */
.documents-grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 10px 2px;
}
.documents-grid-layout .modern-document-card {
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.documents-grid-layout .modern-document-card .card-header-strip {
  background-color: #f8f9fa;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  transition: background 0.3s ease;
}
.documents-grid-layout .modern-document-card .card-header-strip .doc-badge {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 6px;
}
.documents-grid-layout .modern-document-card .card-header-strip .doc-date {
  font-size: 0.85rem;
  color: #666;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
}
.documents-grid-layout .modern-document-card .card-header-strip .doc-date .icon-cal {
  font-size: 0.8rem;
}
.documents-grid-layout .modern-document-card .card-content-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1;
}
.documents-grid-layout .modern-document-card .card-content-body .detail-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-label .row-icon {
  font-size: 0.9rem;
  color: #aaa;
}
.documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value {
  font-size: 0.95rem;
  color: #333;
  font-weight: 500;
  padding-left: 2px;
  line-height: 1.4;
  word-break: break-word;
}
.documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.highlight-text {
  color: #2d3748;
  font-weight: 600;
}

/* --- Modern Notes Grid View Styles --- */
.notes-grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 10px 2px;
}
.notes-grid-layout .modern-note-card {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
}
.notes-grid-layout .modern-note-card .card-header-strip {
  background-color: #f8fafb;
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #e2e8f0;
  transition: background 0.3s ease;
  gap: 10px;
}
.notes-grid-layout .modern-note-card .card-header-strip .header-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}
.notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.4;
}
.notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge .type-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}
.notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge .title-text {
  word-break: break-word;
}
.notes-grid-layout .modern-note-card .card-header-strip .header-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
  margin-left: auto;
}
.notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}
.notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn.edit-btn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn.delete-btn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.notes-grid-layout .modern-note-card .card-content-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
}
.notes-grid-layout .modern-note-card .card-content-body .detail-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #6b7280;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-label .row-icon {
  font-size: 0.9rem;
  color: #9ca3af;
}
.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value {
  font-size: 0.9rem;
  color: #1f2937;
  font-weight: 500;
  padding-left: 2px;
  line-height: 1.5;
  word-break: break-word;
}
.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text {
  color: #4b5563;
  max-height: 150px;
  overflow-y: auto;
  padding-right: 4px;
  /* Custom scrollbar */
}
.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar {
  width: 3px;
}
.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 4px;
}
.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text .read-more-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  font-size: 0.8rem;
  margin-left: 5px;
  padding: 0;
}
.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text .read-more-btn:hover {
  text-decoration: underline;
  color: var(--primary-color);
}

@media (max-width: 480px) {
  .notes-grid-layout {
    grid-template-columns: 1fr;
  }
  .notes-grid-layout .modern-note-card .card-header-strip {
    padding: 10px;
  }
}
/* --- Modern Tasks Grid View Styles --- */
.tasks-grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 10px 2px;
}
.tasks-grid-layout .modern-task-card {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
}
.tasks-grid-layout .modern-task-card .card-header-strip {
  background-color: #f8fafb;
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #e2e8f0;
  transition: background 0.3s ease;
  gap: 10px;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.4;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge .type-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge .title-text {
  word-break: break-word;
  color: var(--primary-color);
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill.new {
  background-color: #dcfce7;
  color: #166534;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill.updated {
  background-color: #e0f2fe;
  color: #075985;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
  margin-left: auto;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn.edit-btn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn.delete-btn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.tasks-grid-layout .modern-task-card .card-content-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
}
.tasks-grid-layout .modern-task-card .card-content-body .recurring-info {
  background-color: #fff7ed;
  color: #c2410c;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px dashed #fdba74;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #6b7280;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-label .row-icon {
  font-size: 0.9rem;
  color: #9ca3af;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value {
  font-size: 0.9rem;
  color: #1f2937;
  font-weight: 500;
  padding-left: 2px;
  line-height: 1.5;
  word-break: break-word;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge.completed {
  background-color: #d1fae5;
  color: #047857;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge.pending {
  background-color: #fee2e2;
  color: #b91c1c;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text {
  color: #4b5563;
  max-height: 150px;
  overflow-y: auto;
  padding-right: 4px;
  /* Custom scrollbar */
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar {
  width: 3px;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 4px;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text .read-more-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  font-size: 0.8rem;
  margin-left: 5px;
  padding: 0;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text .read-more-btn:hover {
  text-decoration: underline;
  color: var(--primary-color);
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text img {
  max-width: 100%;
  height: auto;
}
.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text p {
  margin: 0 0 4px 0;
}

.task-badge-inline {
  padding: 1px 5px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.task-badge-inline::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.task-badge-inline.new {
  background-color: darkgreen;
}
.task-badge-inline.updated {
  background-color: darkcyan;
}

.detail-row-horizontal {
  display: flex;
  gap: 12px;
  width: 100%;
}
.detail-row-horizontal .detail-row-half {
  flex: 1 1;
  min-width: 0;
}
@media (max-width: 480px) {
  .detail-row-horizontal {
    flex-direction: column;
    gap: 8px;
  }
}

@media (max-width: 600px) {
  .header-actions-container {
    flex-direction: column;
    align-items: flex-start !important;
  }
  .header-actions-container .actions-right {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }
}
@media (max-width: 1024px) {
  .tab-content {
    max-height: 50vh;
  }
  .order-card,
  .order-card-doc {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .order-card .doc-content-wrapper,
  .order-card-doc .doc-content-wrapper {
    flex-direction: column;
    width: 100%;
  }
  .order-card .doc-content-wrapper .customer-doc-actions,
  .order-card-doc .doc-content-wrapper .customer-doc-actions {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }
  .order-card .order-det-card,
  .order-card-doc .order-det-card {
    width: 100%;
    flex-direction: column;
  }
  .order-card .order-det-card .ord-det-card1,
  .order-card .order-det-card .ord-det-card2,
  .order-card-doc .order-det-card .ord-det-card1,
  .order-card-doc .order-det-card .ord-det-card2 {
    width: 100%;
  }
  .order-card .note-div-detail,
  .order-card .order-expense-card,
  .order-card .task-div-detail,
  .order-card .doc-div-detail,
  .order-card-doc .note-div-detail,
  .order-card-doc .order-expense-card,
  .order-card-doc .task-div-detail,
  .order-card-doc .doc-div-detail {
    width: 100%;
    flex-direction: column;
  }
  .order-card .note-div-detail div,
  .order-card .order-expense-card div,
  .order-card .task-div-detail div,
  .order-card .doc-div-detail div,
  .order-card-doc .note-div-detail div,
  .order-card-doc .order-expense-card div,
  .order-card-doc .task-div-detail div,
  .order-card-doc .doc-div-detail div {
    width: 100%;
  }
  .order-card .editdel,
  .order-card-doc .editdel {
    justify-content: flex-start;
  }
  .tab-buttons-with-info {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .tab-buttons-with-info .tab-buttons {
    justify-content: flex-start;
    overflow-x: auto;
    white-space: nowrap;
  }
  .tab-buttons-with-info .tab-buttons button {
    flex-shrink: 0;
  }
  .tab-buttons-with-info .tab-info-container {
    margin-left: 0;
    padding-left: 0;
    align-self: flex-end;
  }
  .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {
    width: 280px;
    right: -10px;
  }
  .tab-header .info-button .info-tooltip {
    width: 250px;
    right: -10px;
  }
}
@media (max-width: 768px) {
  .tab-container {
    padding: 16px;
  }
  .tab-container .tab-buttons-with-info .tab-buttons {
    gap: 6px;
  }
  .tab-container .tab-buttons-with-info .tab-buttons button {
    padding: 6px 12px;
    font-size: 13px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container {
    padding-left: 12px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container .info-button {
    width: 26px;
    height: 26px;
    font-size: 13px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {
    width: 250px;
    right: -20px;
    font-size: 12px;
  }
  .tab-content {
    gap: 12px;
    padding-right: 4px;
  }
  .order-card,
  .order-card-doc {
    padding: 16px;
  }
  .order-card p,
  .order-card-doc p {
    font-size: 14px;
  }
  .order-card .editdel > button,
  .order-card-doc .editdel > button {
    width: auto;
    padding: 6px 12px;
  }
  .simple-item {
    font-size: 13px;
  }
  .timeline-container {
    margin: 12px;
  }
  .timeline-container .timeline-dot {
    width: 12px;
    height: 12px;
  }
  .timeline-container .tooltip {
    min-width: 280px;
    font-size: 13px;
  }
  .modal {
    max-width: 95vw !important;
  }
  .tab-header .info-button .info-tooltip {
    width: 220px;
    right: -20px;
    font-size: 12px;
  }
}
@media (max-width: 480px) {
  .tab-container .tab-buttons-with-info .tab-buttons {
    gap: 4px;
  }
  .tab-container .tab-buttons-with-info .tab-buttons button {
    font-size: 12px;
    padding: 5px 10px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container {
    padding-left: 8px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container .info-button {
    width: 24px;
    height: 24px;
    font-size: 12px;
    border-width: 1px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {
    width: 220px;
    right: -30px;
    font-size: 11px;
    padding: 10px 12px;
  }
  .order-card {
    align-items: flex-start !important;
  }
  .order-card .note-div-detail,
  .order-card .order-expense-card,
  .order-card .task-div-detail {
    display: block !important;
    justify-content: space-between !important;
    width: 100% !important;
  }
  .order-card .note-div-detail div,
  .order-card .order-expense-card div,
  .order-card .task-div-detail div {
    width: 100% !important;
  }
  .order-card,
  .order-card-doc {
    padding: 12px;
  }
  .order-card p,
  .order-card-doc p {
    font-size: 13px;
  }
  .order-card .editdel,
  .order-card-doc .editdel {
    align-items: flex-start;
    gap: 6px;
  }
  .order-card .editdel > button,
  .order-card-doc .editdel > button {
    width: 100%;
  }
  .modal {
    padding: 0.5rem;
  }
  .modal .modal-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .modal .modal-actions button {
    width: 100%;
  }
  .modal .task-tab-switcher {
    flex-direction: column;
  }
  .modal .task-tab-switcher .task-tab-btn {
    width: 100%;
  }
  .modal .assigned-due {
    flex-direction: column;
    gap: 0.5rem;
  }
  .tooltip {
    min-width: 90vw;
    padding: 10px;
  }
  .tab-header .info-button {
    width: 20px;
    height: 20px;
    font-size: 12px;
  }
  .tab-header .info-button .info-tooltip {
    width: 200px;
    right: -30px;
    font-size: 11px;
    padding: 10px 12px;
  }
}
.custom-columns-content {
  padding: 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.custom-columns-content .custom-columns-form {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
}
.custom-columns-content .custom-columns-form .custom-column-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.custom-columns-content .custom-columns-form .custom-column-field label {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  text-transform: capitalize;
}
.custom-columns-content .custom-columns-form .custom-column-field .custom-column-input {
  padding: 10px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  transition: all 0.2s;
}
.custom-columns-content .custom-columns-form .custom-column-field .custom-column-input:focus {
  outline: none;
  border-color: #004A9A;
  box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);
}
.custom-columns-content .custom-columns-form .custom-column-field .custom-column-input::placeholder {
  color: #94a3b8;
}
.custom-columns-content .custom-columns-form .custom-column-field .column-type {
  font-size: 12px;
  color: #64748b;
  font-style: italic;
}

@media (max-width: 768px) {
  .custom-columns-content {
    padding: 16px;
  }
  .custom-columns-content .custom-columns-form {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/TabViewer.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAEF;AACE;EACE,mBAAA;EACA,kCAAA;AACJ;AACI;EACE,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,+CAAA;AACN;AACM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACR;AACQ;EACE,eAAA;EACA,6BAAA;AACV;AAEQ;EACE,eAAA;EACA,gBAAA;AAAV;AAIM;EACE,aAAA;EACA,QAAA;AAFR;AAIQ;EACE,oCAAA;EACA,YAAA;EACA,0CAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAFV;AAIU;EACE,oCAAA;EACA,2BAAA;AAFZ;AAKU;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;AAHZ;AAKY;EACE,qCAAA;AAHd;AAWE;EACE;IACE,UAAA;IACA,4BAAA;EATJ;EAWE;IACE,UAAA;IACA,wBAAA;EATJ;AACF;AAYE;EACE;IAEE,wBAAA;EAXJ;EAaE;IACE,2BAAA;EAXJ;AACF;AAcE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAZJ;AAcI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+CAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;AAZN;AAcM;EACE,oDAAA;EACA,qBAAA;AAZR;AAcQ;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AAZV;AAgBM;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;AAdR;AAgBQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;AAdV;AAiBQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,WAAA;AAfV;AAqBE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,eAAA;EACA,WAAA;AAnBJ;AAqBI;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AAnBN;AAqBM;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAnBR;AAqBQ;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;AAnBV;AAsBQ;EACE;IACE,qBAAA;IACA,UAAA;EApBV;EAuBQ;IACE,mBAAA;IACA,UAAA;EArBV;AACF;AAwBQ;EACE,oDAAA;EACA,iBAAA;EACA,2BAAA;EACA,uBAAA;AAtBV;AAyBQ;EACE,yBAAA;AAvBV;AA4BI;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA1BN;AA4BM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,mFAAA;EAKA,YAAA;EACA,0CAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,4CAAA;AA/BR;AAiCQ;EACE,aAAA;EACA,4CAAA;AA/BV;AAkCQ;EACE,6DAAA;EACA,sBAAA;EACA,6CAAA;AAhCV;AAkCU;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AAhCZ;AAoCQ;EACE,sBAAA;AAlCV;AAqCQ;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;AAnCV;AAqCU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;AAnCZ;AAsCU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,WAAA;AApCZ;AA2CE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iCAAA;AA1CJ;AA4CI;EACE,UAAA;AA1CN;AA6CI;EACE,sBAAA;EACA,kBAAA;AA3CN;AA8CI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AA5CN;AA8CM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA5CR;AA+CM;EACE,aAAA;EACA,oBAAA;AA7CR;AA+CQ;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AA7CV;AA+CU;EACE,mBAAA;AA7CZ;AAoDE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kDAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAlDJ;AAoDI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAlDN;AAqDI;EAEE,oBAAA;AApDN;AAsDM;EACE,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,eAAA;AApDR;AAsDQ;EACE,sCAAA;EACA,WAAA;AApDV;AA0DI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;AAxDN;AA0DM;;EAEE,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAxDR;AA0DQ;;EACE,sCAAA;EACA,WAAA;EACA,kCAAA;AAvDV;AA4DQ;EACE,sCAAA;EACA,WAAA;AA1DV;AA+DI;EACE,0CAAA;AA7DN;AAgEI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AA9DN;AAgEM;EACE,cAAA;AA9DR;AAkEI;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,qBAAA;AAhEN;AAkEM;EACE,0BAAA;AAhER;AAoEI;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AAlEN;AAoEM;EACE,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,YAAA;AAlER;AAqEM;EAEE,uCAAA;AApER;AAsEQ;EACE,uCAAA;AApEV;AAwEM;EACE,0CAAA;AAtER;AAwEQ;EACE,oCAAA;AAtEV;AA2EI;EACE,aAAA;EACA,8BAAA;EACA,UAAA;AAzEN;AA2EM;EACE,UAAA;AAzER;AA8EE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AA5EJ;AA8EI;EACE,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AA5EN;AA8EM;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AA5ER;AAiFE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,4CAAA;EACA,kDAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AA/EJ;AAiFI;EACE,0CAAA;AA/EN;AAkFI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAhFN;AAkFM;EACE,cAAA;AAhFR;AAoFI;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,qBAAA;AAlFN;AAoFM;EACE,0BAAA;AAlFR;AAsFI;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AApFN;AAsFM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,WAAA;AApFR;AAwFI;;;EAGE,aAAA;EACA,8BAAA;EAEA,UAAA;AAvFN;AAyFM;;;EACE,UAAA;AArFR;AAyFI;EACE,UAAA;EACA,aAAA;EACA,8BAAA;AAvFN;AAyFM;EACE,UAAA;AAvFR;AA0FM;EACE,UAAA;AAxFR;AA6FE;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AA3FJ;AA6FI;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AA3FN;AA+FE;EACE,2BAAA;AA7FJ;AAgGE;EACE,0BAAA;AA9FJ;AAiGE;EACE,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AA/FJ;AAiGI;EACE,gBAAA;AA/FN;AAmGE;EACE,aAAA;AAjGJ;AAoGE;EACE,2BAAA;EACA,qBAAA;AAlGJ;AAoGI;EACE,0BAAA;AAlGN;AAsGE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AApGJ;AAsGI;EACE,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AArGN;AAuGM;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;AArGR;AAwGM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtGR;AAwGQ;EACE,gBAAA;AAtGV;AAyGQ;;;EAGE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAvGV;AA2GM;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAzGR;AA2GQ;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;AAzGV;AA2GU;EACE,yBAAA;EACA,WAAA;AAzGZ;AA2GY;EACE,yBAAA;AAzGd;AA6GU;EACE,yBAAA;EACA,WAAA;AA3GZ;AA6GY;EACE,yBAAA;AA3Gd;AAiHM;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA/GR;AAiHQ;EACE,SAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AA/GV;AAiHU;EACE,yBAAA;AA/GZ;AAkHU;EACE,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,wCAAA;AAhHZ;AAqHM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAnHR;AAqHQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;AAnHV;AAqHU;EANF;IAOI,UAAA;EAlHV;AACF;AAqHY;EACE,qBAAA;AAnHd;AAqHc;EACE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AAnHhB;AAuHY;EACE,aAAA;EACA,eAAA;EACA,WAAA;AArHd;AAuHc;EACE,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AArHhB;AAuHgB;EACE,oBAAA;AArHlB;AAwHgB;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;AAtHlB;AAwHkB;EACE,cAAA;AAtHpB;AAiIE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;AA/HJ;AAiII;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA/HN;AAkII;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AAhIN;AAkIM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,4CAAA;EACA,eAAA;EACA,+BAAA;AAhIR;AAkIQ;EACE,mBAAA;EACA,cAAA;AAhIV;AAkIU;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;AAhIZ;AAoIQ;EACE,sBAAA;EACA,6CAAA;AAlIV;AAqIQ;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,2CAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAnIV;AAqIU;EACE,kBAAA;AAnIZ;AAwIM;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,WAAA;AAvIR;AAyIQ;EACE,SAAA;AAvIV;;AA8IA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA3IF;AA6IE;EACE;IAEE,YAAA;IACA,mBAAA;EA5IJ;EA8IE;IACE,YAAA;IACA,sBAAA;EA5IJ;AACF;AA+IE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AA7IJ;AAgJE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AA9IJ;AAkJE;EA5CF;IA6CI,kBAAA;IACA,iBAAA;EA/IF;EAiJE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EA/IJ;EAkJE;IACE,kBAAA;EAhJJ;AACF;;AAoJA;EACE,yBAAA;AAjJF;AAkJE;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;AAhJJ;AAkJI;EACE,WAAA;AAhJN;AAkJI;EACE,yBAAA;EACA,kBAAA;AAhJN;AAoJE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,yCAAA;EACA,8CAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8DAAA;AAlJJ;AAoJI;EACE,yBAAA;AAlJN;AAoJM;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,qDAAA;EACA,mBAAA;AAlJR;AAuJM;EACE,sCAAA;AArJR;AAuJQ;EACE,yBAAA;AArJV;AAwJQ;EACE,qDAAA;AAtJV;AAyJQ;EACE,oBAAA;EACA,cAAA;EACA,sBAAA;AAvJV;;AA8JA;EACE,eAAA;AA3JF;;AA8JA;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AA3JF;;AA8JA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA3JF;;AA8JA;EACE,0BAAA;EACA,aAAA;EACA,kBAAA;AA3JF;;AA8JA;EACE,iBAAA;AA3JF;;AA8JA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AA3JF;;AA8JA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AA3JF;;AA8JA;EACE,cAAA;AA3JF;;AA8JA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA3JF;;AA8JA;EACE,yBAAA;EACA,YAAA;AA3JF;;AA8JA;EACE,gBAAA;AA3JF;;AA8JA;;EAEE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA3JF;;AA8JA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AA3JF;AA6JE;;EAEE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA3JJ;AA8JE;EACE,yBAAA;AA5JJ;;AAgKA;EACE,gBAAA;AA7JF;AA+JE;EACE,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,eAAA;AA7JJ;AA+JI;EACE,sCAAA;EACA,WAAA;AA7JN;;AAkKA;EAEE,eAAA;EACA,SAAA;EACA,mBAAA;AAhKF;;AAmKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAhKF;AAkKE;EACE,aAAA;EAIA,QAAA;AAnKJ;AAqKI;EAuBE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAzLN;AA2LM;EACE,eAAA;EACA,cAAA;AAzLR;AA4LM;EACE,yBAAA;AA1LR;AA6LM;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AA3LR;;AAkMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA/LF;;AAmMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAhMF;AAkME;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,WAAA;AAhMJ;AAkNA,6DAAA;AAEA;EACE,aAAA;EAEA,4DAAA;EACA,SAAA;EACA,iBAAA;AAlNF;AAoNE;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,qDAAA;AAlNJ;AAmOI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,sCAAA;AAjON;AAmOM;EACE,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAjOR;AAoOM;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAlOR;AAuOI;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AArON;AAuOM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AArOR;AAuOQ;EACE,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AArOV;AAuOU;EACE,iBAAA;EACA,WAAA;AArOZ;AAyOQ;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAvOV;AAyOU;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAvOZ;AA8OI;EACE,kBAAA;EACA,6BAAA;EACA,sBAAA;EAEA,mBAAA;EACA,aAAA;EACA,oBAAA,EAAA,uDAAA;EACA,8BAAA;EACA,QAAA;EAEA,yCAAA;EA6CA,sCAAA;AA1RN;AA8OM;;;;;EAKE,SAAA;EACA,YAAA;EAEA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA,EAAA,oCAAA;AA9OR;AAiPM;EACE,+CAAA;EACA,yCAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA/OR;AAiPQ;EACE,+CAAA;EACA,YAAA;AA/OV;AAmPM;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,yCAAA;AAjPR;;AA6PA,6CAAA;AAEA;EACE,aAAA;EAEA,4DAAA;EACA,SAAA;EACA,iBAAA;AA5PF;AA8PE;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,qDAAA;AA5PJ;AA6QI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AA3QN;AA6QM;EACE,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA3QR;AA8QM;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA5QR;AA8QQ;EACE,iBAAA;AA5QV;AAkRI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;AAhRN;AAkRM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhRR;AAkRQ;EACE,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAhRV;AAkRU;EACE,iBAAA;EACA,WAAA;AAhRZ;AAoRQ;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAlRV;AAoRU;EACE,cAAA;EACA,gBAAA;AAlRZ;;AA0RA,0CAAA;AAEA;EACE,aAAA;EAEA,4DAAA;EACA,SAAA;EACA,iBAAA;AAzRF;AA2RE;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EAEA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AA1RJ;AA6RI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,gCAAA;EACA,SAAA;AA3RN;AA6RM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AA3RR;AA6RQ;EACE,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA3RV;AA6RU;EACE,iBAAA;EACA,cAAA;AA3RZ;AA8RU;EACE,sBAAA;AA5RZ;AAiSM;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;AA/RR;AAiSQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AA/RV;AAmSY;EAIE,+BAAA;EACA,YAAA;AApSd;AA0SY;EAIE,+BAAA;EACA,YAAA;AA3Sd;AAmTI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;AAjTN;AAmTM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAjTR;AAmTQ;EACE,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAjTV;AAmTU;EACE,iBAAA;EACA,cAAA;AAjTZ;AAqTQ;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAnTV;AAqTU;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,qBAAA;AApTZ;AAqTY;EACE,UAAA;AAnTd;AAqTY;EACE,yBAAA;EACA,kBAAA;AAnTd;AAsTY;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AApTd;AAsTc;EACE,0BAAA;EACA,2BAAA;AApThB;;AA+TA;EACE;IACE,0BAAA;EA5TF;EA8TE;IACE,aAAA;EA5TJ;AACF;AAgUA,0CAAA;AAEA;EACE,aAAA;EAEA,4DAAA;EACA,SAAA;EACA,iBAAA;AAhUF;AAkUE;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EAEA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAjUJ;AAoUI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,gCAAA;EACA,SAAA;AAlUN;AAoUM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAlUR;AAoUQ;EACE,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAlUV;AAoUU;EACE,iBAAA;EACA,cAAA;AAlUZ;AAqUU;EACE,sBAAA;EACA,2BAAA;AAnUZ;AAuUQ;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AArUV;AAuUU;EACE,yBAAA;EACA,cAAA;AArUZ;AAuUU;EACE,yBAAA;EACA,cAAA;AArUZ;AA0UM;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;AAxUR;AA0UQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAxUV;AA2UY;EAIE,+BAAA;EACA,YAAA;AA5Ud;AAiVY;EAIE,+BAAA;EACA,YAAA;AAlVd;AA0VI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;AAxVN;AA0VM;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;AAxVR;AA2VM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAzVR;AA2VQ;EACE,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAzVV;AA2VU;EACE,iBAAA;EACA,cAAA;AAzVZ;AA6VQ;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AA3VV;AA6VU;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA3VZ;AA6VY;EACE,yBAAA;EACA,cAAA;AA3Vd;AA6VY;EACE,yBAAA;EACA,cAAA;AA3Vd;AA+VU;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,qBAAA;AA9VZ;AA+VY;EACE,UAAA;AA7Vd;AA+VY;EACE,yBAAA;EACA,kBAAA;AA7Vd;AAgWY;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AA9Vd;AAgWc;EACE,0BAAA;EACA,2BAAA;AA9VhB;AAmWY;EACE,eAAA;EACA,YAAA;AAjWd;AAmWY;EACE,iBAAA;AAjWd;;AA2WA;EAkBE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AAzXF;AA2XE;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AAzXJ;AA4XE;EACE,2BAAA;AA1XJ;AA6XE;EACE,0BAAA;AA3XJ;;AA8XA;EACE,aAAA;EACA,SAAA;EACA,WAAA;AA3XF;AA6XE;EACE,SAAA;EACA,YAAA;AA3XJ;AA8XE;EAVF;IAWI,sBAAA;IACA,QAAA;EA3XF;AACF;;AA8XA;EACE;IACE,sBAAA;IACA,kCAAA;EA3XF;EA6XE;IACE,cAAA;IACA,WAAA;IACA,8BAAA;EA3XJ;AACF;AA+XA;EACE;IACE,gBAAA;EA7XF;EAgYA;;IAEE,sBAAA;IACA,uBAAA;IACA,SAAA;EA9XF;EAgYE;;IACE,sBAAA;IACA,WAAA;EA7XJ;EA+XI;;IACE,mBAAA;IACA,mBAAA;IACA,2BAAA;IACA,WAAA;EA5XN;EAgYE;;IACE,WAAA;IACA,sBAAA;EA7XJ;EA+XI;;;;IAEE,WAAA;EA3XN;EA+XE;;;;;;;;IAIE,WAAA;IACA,sBAAA;EAzXJ;EA2XI;;;;;;;;IACE,WAAA;EAlXN;EAsXE;;IACE,2BAAA;EAnXJ;EAuXA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;EArXF;EAuXE;IACE,2BAAA;IACA,gBAAA;IACA,mBAAA;EArXJ;EAuXI;IACE,cAAA;EArXN;EAyXE;IACE,cAAA;IACA,eAAA;IACA,oBAAA;EAvXJ;EA0XM;IACE,YAAA;IACA,YAAA;EAxXR;EAgYI;IACE,YAAA;IACA,YAAA;EA9XN;AACF;AAmYA;EACE;IACE,aAAA;EAjYF;EAoYI;IACE,QAAA;EAlYN;EAoYM;IACE,iBAAA;IACA,eAAA;EAlYR;EAsYI;IACE,kBAAA;EApYN;EAsYM;IACE,WAAA;IACA,YAAA;IACA,eAAA;EApYR;EAsYQ;IACE,YAAA;IACA,YAAA;IACA,eAAA;EApYV;EA2YA;IACE,SAAA;IACA,kBAAA;EAzYF;EA4YA;;IAEE,aAAA;EA1YF;EA4YE;;IACE,eAAA;EAzYJ;EA4YE;;IACE,WAAA;IACA,iBAAA;EAzYJ;EA6YA;IACE,eAAA;EA3YF;EA8YA;IACE,YAAA;EA5YF;EA8YE;IACE,WAAA;IACA,YAAA;EA5YJ;EA+YE;IACE,gBAAA;IACA,eAAA;EA7YJ;EAiZA;IACE,0BAAA;EA/YF;EAoZI;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAlZN;AACF;AAuZA;EAGM;IACE,QAAA;EAvZN;EAyZM;IACE,eAAA;IACA,iBAAA;EAvZR;EA2ZI;IACE,iBAAA;EAzZN;EA2ZM;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAzZR;EA2ZQ;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;EAzZV;EAgaA;IACE,kCAAA;EA9ZF;EAgaE;;;IAGE,yBAAA;IACA,yCAAA;IACA,sBAAA;EA9ZJ;EAgaI;;;IACE,sBAAA;EA5ZN;EAiaA;;IAEE,aAAA;EA/ZF;EAiaE;;IACE,eAAA;EA9ZJ;EAiaE;;IACE,uBAAA;IACA,QAAA;EA9ZJ;EAgaI;;IACE,WAAA;EA7ZN;EAkaA;IACE,eAAA;EAhaF;EAkaE;IACE,sBAAA;IACA,oBAAA;IACA,QAAA;EAhaJ;EAkaI;IACE,WAAA;EAhaN;EAoaE;IACE,sBAAA;EAlaJ;EAoaI;IACE,WAAA;EAlaN;EAsaE;IACE,sBAAA;IACA,WAAA;EApaJ;EAwaA;IACE,eAAA;IACA,aAAA;EAtaF;EA0aE;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAxaJ;EA0aI;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;EAxaN;AACF;AA8aA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;AA5aF;AA8aE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AA5aJ;AA8aI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA5aN;AA8aM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AA5aR;AA+aM;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AA7aR;AA+aQ;EACE,aAAA;EACA,qBAAA;EACA,2CAAA;AA7aV;AAgbQ;EACE,cAAA;AA9aV;AAkbM;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAhbR;;AAsbA;EACE;IACE,aAAA;EAnbF;EAqbE;IACE,0BAAA;EAnbJ;AACF","sourcesContent":["@charset \"UTF-8\";\n.tab-container {\n  padding: 24px;\n  background-color: #f4f6f8;\n  position: relative;\n  margin-top: 10px;\n}\n.tab-container .global-upload-notification {\n  margin-bottom: 16px;\n  animation: slideDown 0.3s ease-out;\n}\n.tab-container .global-upload-notification .upload-banner {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n.tab-container .global-upload-notification .upload-banner .upload-banner-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.tab-container .global-upload-notification .upload-banner .upload-banner-left .upload-icon {\n  font-size: 20px;\n  animation: bounce 2s infinite;\n}\n.tab-container .global-upload-notification .upload-banner .upload-banner-left .upload-text {\n  font-size: 14px;\n  font-weight: 500;\n}\n.tab-container .global-upload-notification .upload-banner .upload-banner-right {\n  display: flex;\n  gap: 8px;\n}\n.tab-container .global-upload-notification .upload-banner .upload-banner-right button {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.tab-container .global-upload-notification .upload-banner .upload-banner-right button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n.tab-container .global-upload-notification .upload-banner .upload-banner-right button.view-uploads-btn {\n  background: white;\n  color: #667eea;\n  border-color: white;\n}\n.tab-container .global-upload-notification .upload-banner .upload-banner-right button.view-uploads-btn:hover {\n  background: rgba(255, 255, 255, 0.95);\n}\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-5px);\n  }\n}\n.tab-container .tab-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n.tab-container .tab-header .info-button {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--primary-color, #007bff);\n  color: white;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  z-index: 15;\n}\n.tab-container .tab-header .info-button:hover {\n  background-color: var(--primary-color-dark, #0056b3);\n  transform: scale(1.1);\n}\n.tab-container .tab-header .info-button:hover .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n.tab-container .tab-header .info-button .info-tooltip {\n  position: absolute;\n  bottom: 35px;\n  right: 0;\n  background: white;\n  color: #333;\n  padding: 12px 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  font-size: 13px;\n  line-height: 1.4;\n  width: 280px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.3s ease;\n  z-index: 1000;\n  border: 1px solid #e0e0e0;\n}\n.tab-container .tab-header .info-button .info-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  right: 12px;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid white;\n}\n.tab-container .tab-header .info-button .info-tooltip::before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  right: 11px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 7px solid #e0e0e0;\n  z-index: -1;\n}\n.tab-container .tab-buttons-with-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 16px;\n  background-color: inherit;\n  position: sticky;\n  top: 0;\n  padding: 12px 0;\n  z-index: 10;\n}\n.tab-container .tab-buttons-with-info .tab-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n}\n.tab-container .tab-buttons-with-info .tab-buttons button {\n  padding: 8px 14px;\n  background: #f1f1f1;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background 0.2s;\n  border: none;\n  font-size: 14px;\n  color: #333;\n  display: flex;\n  align-items: flex-start;\n}\n.tab-container .tab-buttons-with-info .tab-buttons button .tab-bubble {\n  background-color: crimson;\n  color: white;\n  font-size: 11px;\n  font-weight: bold;\n  border-radius: 10px;\n  padding: 2px 6px;\n  margin-left: 6px;\n  animation: popIn 0.3s ease-in-out;\n}\n@keyframes popIn {\n  from {\n    transform: scale(0.7);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.tab-container .tab-buttons-with-info .tab-buttons button.active {\n  border-bottom: 2px solid var(--primary-border-color);\n  font-weight: bold;\n  color: var(--primary-color);\n  background-color: white;\n}\n.tab-container .tab-buttons-with-info .tab-buttons button:not(.active):hover {\n  background-color: #e0e0e0;\n}\n.tab-container .tab-buttons-with-info .tab-info-container {\n  margin-left: auto;\n  padding-left: 20px;\n  display: flex;\n  align-items: center;\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button {\n  position: relative;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--primary-color, #007bff) 0%, #0056b3 100%);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 15;\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button:hover {\n  background: linear-gradient(135deg, #0056b3 0%, #004494 100%);\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button:hover .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button:active {\n  transform: scale(0.95);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {\n  position: absolute;\n  bottom: 35px;\n  right: 0;\n  background: white;\n  color: #333;\n  padding: 12px 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  font-size: 13px;\n  line-height: 1.4;\n  width: 320px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.3s ease;\n  z-index: 1000;\n  border: 1px solid #e0e0e0;\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  right: 12px;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid white;\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip::before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  right: 11px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 7px solid #e0e0e0;\n  z-index: -1;\n}\n.tab-container .tab-content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  padding-right: 8px;\n  background-color: inherit;\n  margin-top: 12px;\n  overflow-y: auto;\n  border-radius: 8px;\n  scrollbar-width: thin;\n  scrollbar-color: #ccc transparent;\n}\n.tab-container .tab-content::-webkit-scrollbar {\n  width: 6px;\n}\n.tab-container .tab-content::-webkit-scrollbar-thumb {\n  background-color: #bbb;\n  border-radius: 4px;\n}\n.tab-container .tab-content .summary {\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.tab-container .tab-content .summary .sum-amount {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.tab-container .tab-content .summary .tab-add {\n  display: flex;\n  justify-content: end;\n}\n.tab-container .tab-content .summary .tab-add > button {\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  padding: 8px 18px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n.tab-container .tab-content .summary .tab-add > button:hover {\n  background: #0052a3;\n}\n.tab-container .order-card-doc {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 20px;\n  border-left: 4px solid var(--primary-border-color);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.tab-container .order-card-doc .doc-content-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n.tab-container .order-card-doc .tab-add {\n  justify-content: end;\n}\n.tab-container .order-card-doc .tab-add .view-doc-cases {\n  padding: 0.5rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  color: var(--primary-color);\n  background-color: #fff;\n  cursor: pointer;\n}\n.tab-container .order-card-doc .tab-add .view-doc-cases:hover {\n  background-color: var(--primary-color);\n  color: #fff;\n}\n.tab-container .order-card-doc .customer-doc-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-end;\n  justify-content: flex-start;\n  margin-top: 0;\n  flex-shrink: 0;\n}\n.tab-container .order-card-doc .customer-doc-actions .upload-btn-add-docs,\n.tab-container .order-card-doc .customer-doc-actions .view-doc-cases {\n  padding: 0.5rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  color: var(--primary-color);\n  background-color: #fff;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n.tab-container .order-card-doc .customer-doc-actions .upload-btn-add-docs:hover,\n.tab-container .order-card-doc .customer-doc-actions .view-doc-cases:hover {\n  background-color: var(--primary-color);\n  color: #fff;\n  border-color: var(--primary-color);\n}\n.tab-container .order-card-doc .customer-doc-actions .upload-btn-add-docs:hover {\n  background-color: var(--primary-color);\n  color: #fff;\n}\n.tab-container .order-card-doc:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n.tab-container .order-card-doc p {\n  margin: 6px 0;\n  font-size: 15px;\n  color: #333;\n}\n.tab-container .order-card-doc p strong {\n  color: #1a1a1a;\n}\n.tab-container .order-card-doc a {\n  display: inline-block;\n  color: var(--primary-color);\n  font-weight: 500;\n  text-decoration: none;\n}\n.tab-container .order-card-doc a:hover {\n  text-decoration: underline;\n}\n.tab-container .order-card-doc .editdel {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 10px;\n}\n.tab-container .order-card-doc .editdel > button {\n  color: var(--text-color);\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  width: 150px;\n}\n.tab-container .order-card-doc .editdel .editbtn {\n  background-color: rgba(27, 42, 78, 0.8);\n}\n.tab-container .order-card-doc .editdel .editbtn:hover {\n  background-color: rgba(27, 42, 78, 0.9);\n}\n.tab-container .order-card-doc .editdel .delbtn {\n  background-color: rgba(239, 107, 110, 0.9);\n}\n.tab-container .order-card-doc .editdel .delbtn:hover {\n  background-color: rgb(239, 107, 110);\n}\n.tab-container .order-card-doc .doc-div-detail {\n  display: flex;\n  justify-content: space-between;\n  width: 70%;\n}\n.tab-container .order-card-doc .doc-div-detail div {\n  width: 50%;\n}\n.tab-container .additional-doc-cards {\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  position: relative;\n}\n.tab-container .additional-doc-cards .doc-status-badge {\n  background-color: darkgreen;\n  position: absolute;\n  top: 0px;\n  right: 0;\n  padding: 4px 10px 4px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.tab-container .additional-doc-cards .doc-status-badge::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.tab-container .order-card {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px var(--boxshadow-color);\n  border-left: 4px solid var(--primary-border-color);\n  transition: box-shadow 0.3s ease;\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.tab-container .order-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n.tab-container .order-card p {\n  margin: 6px 0;\n  font-size: 15px;\n  color: #333;\n}\n.tab-container .order-card p strong {\n  color: #1a1a1a;\n}\n.tab-container .order-card a {\n  display: inline-block;\n  color: var(--primary-color);\n  font-weight: 500;\n  text-decoration: none;\n}\n.tab-container .order-card a:hover {\n  text-decoration: underline;\n}\n.tab-container .order-card .editdel {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 10px;\n}\n.tab-container .order-card .editdel > button {\n  color: #000;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  width: 50px;\n}\n.tab-container .order-card .note-div-detail,\n.tab-container .order-card .order-expense-card,\n.tab-container .order-card .task-div-detail {\n  display: flex;\n  justify-content: space-between;\n  width: 70%;\n}\n.tab-container .order-card .note-div-detail div,\n.tab-container .order-card .order-expense-card div,\n.tab-container .order-card .task-div-detail div {\n  width: 50%;\n}\n.tab-container .order-card .order-det-card {\n  width: 70%;\n  display: flex;\n  justify-content: space-between;\n}\n.tab-container .order-card .order-det-card .ord-det-card1 {\n  width: 60%;\n}\n.tab-container .order-card .order-det-card .ord-det-card2 {\n  width: 30%;\n}\n.tab-container .task-badge {\n  position: absolute;\n  top: 0px;\n  right: 0;\n  padding: 4px 10px 4px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.tab-container .task-badge::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.tab-container .task-badge.new {\n  background-color: darkgreen;\n}\n.tab-container .task-badge.updated {\n  background-color: darkcyan;\n}\n.tab-container .simple-item {\n  background-color: var(--primary-background-color);\n  padding: 16px;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px var(--boxshadow-color);\n  border-left: 3px solid #8884d8;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 14px;\n  color: #444;\n}\n.tab-container .simple-item:last-child {\n  margin-bottom: 0;\n}\n.tab-container .pagination {\n  display: none;\n}\n.tab-container a {\n  color: var(--primary-color);\n  text-decoration: none;\n}\n.tab-container a:hover {\n  text-decoration: underline;\n}\n.tab-container .modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  z-index: 1000;\n}\n.tab-container .modal-backdrop .modal {\n  max-height: 80vh;\n  overflow-y: auto;\n  border-radius: 8px;\n  background-color: white;\n  width: 100%;\n  max-width: 600px;\n}\n.tab-container .modal-backdrop .modal h2 {\n  margin-top: 0;\n  font-size: 1.2rem;\n  margin-bottom: 16px;\n}\n.tab-container .modal-backdrop .modal form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.tab-container .modal-backdrop .modal form label {\n  font-weight: 500;\n}\n.tab-container .modal-backdrop .modal form input,\n.tab-container .modal-backdrop .modal form textarea,\n.tab-container .modal-backdrop .modal form select {\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  resize: vertical;\n  font-family: inherit;\n}\n.tab-container .modal-backdrop .modal .modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n.tab-container .modal-backdrop .modal .modal-actions button {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n.tab-container .modal-backdrop .modal .modal-actions button[type=submit] {\n  background-color: #28a745;\n  color: #fff;\n}\n.tab-container .modal-backdrop .modal .modal-actions button[type=submit]:hover {\n  background-color: #218838;\n}\n.tab-container .modal-backdrop .modal .modal-actions button[type=button] {\n  background-color: #6c757d;\n  color: #fff;\n}\n.tab-container .modal-backdrop .modal .modal-actions button[type=button]:hover {\n  background-color: #5a6268;\n}\n.tab-container .modal-backdrop .modal .task-tab-switcher {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn {\n  flex: 1;\n  padding: 0.5rem 1rem;\n  background-color: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-weight: 500;\n  color: #374151;\n  transition: all 0.2s ease;\n}\n.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn:hover {\n  background-color: #e5e7eb;\n}\n.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn.active {\n  background-color: #2563eb;\n  color: white;\n  border-color: #2563eb;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.tab-container .modal-backdrop .modal .assigned-due {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 0.5rem;\n}\n@media (min-width: 400px) {\n  .tab-container .modal-backdrop .modal .assigned-due .assignedto {\n    width: 48%;\n  }\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .dropdown-container {\n  margin-bottom: 0.5rem;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .dropdown-container .selectInput {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag {\n  background-color: #e0f2f7;\n  color: #0d47a1;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag span {\n  margin-right: 0.3rem;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag .remove-assignee {\n  background: none;\n  border: none;\n  color: #d32f2f;\n  cursor: pointer;\n  font-size: 0.8rem;\n  padding: 0;\n  line-height: 1;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag .remove-assignee:hover {\n  color: #c62828;\n}\n.tab-container .timeline-container {\n  position: relative;\n  margin: 20px;\n  padding: 15px 0;\n  border-left: 4px solid #d0d0d0;\n}\n.tab-container .timeline-container.no-timeline-data {\n  position: relative;\n  margin: 0px;\n  padding: 0px;\n  border-left: none;\n}\n.tab-container .timeline-container .timeline-item {\n  position: relative;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot {\n  position: absolute;\n  left: -9px;\n  top: 5px;\n  width: 15px;\n  height: 15px;\n  background-color: #3a86ff;\n  border-radius: 50%;\n  border: 2px solid white;\n  box-shadow: 0 0 10px rgba(58, 134, 255, 0.4);\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot:hover {\n  transform: scale(1);\n  z-index: 10000;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot:hover .tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n  z-index: 10001;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot.dot-disposed {\n  background-color: #999;\n  box-shadow: 0 0 10px rgba(150, 150, 150, 0.4);\n}\n.tab-container .timeline-container .timeline-item .timeline-dot .tooltip {\n  position: absolute;\n  top: -40px;\n  left: 25px;\n  background: #fff;\n  border-left: 4px solid var(--primary-color);\n  color: #333;\n  padding: 14px;\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  font-size: 14px;\n  min-width: 480px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.3s ease;\n  z-index: 9999;\n  white-space: normal;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot .tooltip div {\n  margin-bottom: 6px;\n}\n.tab-container .timeline-container .timeline-item .timeline-content {\n  margin-left: 20px;\n  padding: 14px 18px;\n  background-color: #fff;\n  border-radius: 10px;\n  font-size: 15px;\n  color: #444;\n}\n.tab-container .timeline-container .timeline-item .timeline-content p {\n  margin: 0;\n}\n\n.no-data-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 1.5rem;\n  text-align: center;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 16px;\n  border: 2px dashed #cbd5e1;\n  min-height: 200px;\n  position: relative;\n  overflow: hidden;\n}\n@keyframes subtle-pulse {\n  0%, 100% {\n    opacity: 0.5;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.05);\n  }\n}\n.no-data-container .no-data-title {\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n  position: relative;\n  z-index: 2;\n}\n.no-data-container .no-data-message {\n  font-size: 1rem;\n  color: #6b7280;\n  max-width: 400px;\n  line-height: 1.5;\n  position: relative;\n  z-index: 2;\n}\n@media (max-width: 768px) {\n  .no-data-container {\n    padding: 2rem 1rem;\n    min-height: 160px;\n  }\n  .no-data-container .no-data-icon {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 1rem;\n  }\n  .no-data-container .no-data-title {\n    font-size: 1.25rem;\n  }\n}\n\n.tab-content {\n  background-color: #f9f9f9;\n}\n.tab-content .table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  padding-bottom: 10px;\n}\n.tab-content .table-responsive::-webkit-scrollbar {\n  height: 6px;\n}\n.tab-content .table-responsive::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 4px;\n}\n.tab-content .documents-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: var(--card-bg, #ffffff);\n  border: 1px solid var(--border-color, #e2e8f0);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  font-size: 0.95rem;\n  box-shadow: 0 2px 6px var(--shadow-light, rgba(0, 0, 0, 0.05));\n}\n.tab-content .documents-table thead {\n  background-color: #f1f5f9;\n}\n.tab-content .documents-table thead th {\n  text-align: left;\n  padding: 1rem;\n  color: #111827;\n  font-weight: 600;\n  border-bottom: 1px solid var(--border-color, #e2e8f0);\n  white-space: nowrap;\n}\n.tab-content .documents-table tbody tr {\n  transition: background-color 0.2s ease;\n}\n.tab-content .documents-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n.tab-content .documents-table tbody tr:not(:last-child) td {\n  border-bottom: 1px solid var(--border-color, #f1f5f9);\n}\n.tab-content .documents-table tbody tr td {\n  padding: 0.9rem 1rem;\n  color: #374151;\n  vertical-align: middle;\n}\n\n.td-th-casedet {\n  font-size: 14px;\n}\n\n.order-card-doc {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 15px;\n  background-color: #fff;\n}\n\n.doc-div-detail {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.added-docs-task-upload-section {\n  border: 1px dashed #0066cc;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.added-docs-task-upload-label {\n  font-weight: bold;\n}\n\n.added-docs-task-upload-click-area {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.added-docs-task-upload-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.added-docs-task-upload-progress {\n  margin: 10px 0;\n}\n\n.added-docs-task-upload-progress-bar {\n  margin-bottom: 10px;\n  background-color: #e0e0e0;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.added-docs-task-upload-progress-indicator {\n  background-color: #0066cc;\n  height: 10px;\n}\n\n.added-docs-task-uploaded-file {\n  margin-top: 10px;\n}\n\n.added-docs-task-upload-cancel-button,\n.added-docs-task-upload-submit-button {\n  margin-right: 10px;\n  background-color: #ff4d4d;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.act-upload-btns {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 10px;\n}\n.act-upload-btns .added-docs-task-upload-cancel-button,\n.act-upload-btns .added-docs-task-upload-submit-button {\n  margin-right: 10px;\n  background-color: #ff4d4d;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.act-upload-btns .added-docs-task-upload-submit-button {\n  background-color: #28a745;\n}\n\n.added-docs-task-upload-button-container {\n  margin-top: 10px;\n}\n.added-docs-task-upload-button-container .upload-btn-add-docs {\n  padding: 0.5rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  color: var(--primary-color);\n  background-color: #fff;\n  cursor: pointer;\n}\n.added-docs-task-upload-button-container .upload-btn-add-docs:hover {\n  background-color: var(--primary-color);\n  color: #fff;\n}\n\n.header-actions-container {\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: center;\n}\n\n.actions-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-left: auto;\n}\n.actions-right .view-toggles {\n  display: flex;\n  gap: 4px;\n}\n.actions-right .view-toggles .toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  background-color: transparent;\n  color: #444;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.actions-right .view-toggles .toggle-btn svg {\n  font-size: 1rem;\n  color: inherit;\n}\n.actions-right .view-toggles .toggle-btn:hover {\n  background-color: #f3f4f6;\n}\n.actions-right .view-toggles .toggle-btn.active {\n  background-color: #e5e7eb;\n  color: #222;\n  border-color: #cbd5e1;\n}\n\n.grid-view-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.editdel-table-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n.editdel-table-actions button {\n  color: #000;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  width: 50px;\n}\n/* --- Modern Grid View Styles (Only affects Grid Mode) --- */\n.orders-grid-layout {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n  padding: 10px 2px;\n}\n.orders-grid-layout .modern-order-card {\n  background-color: #fff;\n  border-radius: 10px;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.orders-grid-layout .modern-order-card .card-header-strip {\n  background-color: #f8f9fa;\n  padding: 12px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  transition: background-color 0.2s ease;\n}\n.orders-grid-layout .modern-order-card .card-header-strip .order-badge {\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--primary-color, #007bff);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.orders-grid-layout .modern-order-card .card-header-strip .order-date {\n  font-size: 0.85rem;\n  color: #666;\n  font-weight: 500;\n}\n.orders-grid-layout .modern-order-card .card-content-body {\n  padding: 16px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.orders-grid-layout .modern-order-card .card-content-body .detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.orders-grid-layout .modern-order-card .card-content-body .detail-row .detail-label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #888;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.orders-grid-layout .modern-order-card .card-content-body .detail-row .detail-label .row-icon {\n  font-size: 0.9rem;\n  color: #aaa;\n}\n.orders-grid-layout .modern-order-card .card-content-body .detail-row .detail-value {\n  font-size: 0.95rem;\n  color: #333;\n  font-weight: 500;\n  padding-left: 2px;\n  line-height: 1.4;\n}\n.orders-grid-layout .modern-order-card .card-content-body .detail-row .detail-value.judge-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.orders-grid-layout .modern-order-card .card-footer-action {\n  padding: 10px 12px;\n  border-top: 1px solid #f0f0f0;\n  background-color: #fff;\n  /* Flexbox Layout */\n  display: flex;\n  align-items: stretch; /* vital: makes both buttons same height if one wraps */\n  justify-content: space-between;\n  gap: 8px;\n  /* Shared styles for both buttons/boxes */\n  /* Specific styles for Upload Button */\n}\n.orders-grid-layout .modern-order-card .card-footer-action .pdf-btn,\n.orders-grid-layout .modern-order-card .card-footer-action .no-doc-status,\n.orders-grid-layout .modern-order-card .card-footer-action > button,\n.orders-grid-layout .modern-order-card .card-footer-action .upload-btn,\n.orders-grid-layout .modern-order-card .card-footer-action .view-uploads-btn {\n  flex: 1;\n  min-width: 0;\n  /* FIX FOR TEXT CUTTING: */\n  white-space: normal;\n  text-align: center;\n  line-height: 1.2;\n  font-size: 0.75rem;\n  padding: 6px 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  height: auto; /* Allows height to grow with text */\n}\n.orders-grid-layout .modern-order-card .card-footer-action .pdf-btn {\n  border: 1px solid var(--primary-color, #007bff);\n  background-color: rgba(0, 123, 255, 0.05);\n  color: var(--primary-color, #007bff);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.orders-grid-layout .modern-order-card .card-footer-action .pdf-btn:hover {\n  background-color: var(--primary-color, #007bff);\n  color: white;\n}\n.orders-grid-layout .modern-order-card .card-footer-action .no-doc-status {\n  color: #dc3545;\n  background-color: #fff5f5;\n  border: 1px solid #dc3545;\n  font-weight: 600;\n  font-size: 0.7rem; /* Make the error text slightly smaller */\n}\n\n/* --- Modern Document Grid View Styles --- */\n.documents-grid-layout {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n  padding: 10px 2px;\n}\n.documents-grid-layout .modern-document-card {\n  background-color: #fff;\n  border-radius: 10px;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.documents-grid-layout .modern-document-card .card-header-strip {\n  background-color: #f8f9fa;\n  padding: 12px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  transition: background 0.3s ease;\n}\n.documents-grid-layout .modern-document-card .card-header-strip .doc-badge {\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--primary-color);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.documents-grid-layout .modern-document-card .card-header-strip .doc-date {\n  font-size: 0.85rem;\n  color: #666;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.documents-grid-layout .modern-document-card .card-header-strip .doc-date .icon-cal {\n  font-size: 0.8rem;\n}\n.documents-grid-layout .modern-document-card .card-content-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  flex: 1;\n}\n.documents-grid-layout .modern-document-card .card-content-body .detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #888;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-label .row-icon {\n  font-size: 0.9rem;\n  color: #aaa;\n}\n.documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value {\n  font-size: 0.95rem;\n  color: #333;\n  font-weight: 500;\n  padding-left: 2px;\n  line-height: 1.4;\n  word-break: break-word;\n}\n.documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.highlight-text {\n  color: #2d3748;\n  font-weight: 600;\n}\n\n/* --- Modern Notes Grid View Styles --- */\n.notes-grid-layout {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  padding: 10px 2px;\n}\n.notes-grid-layout .modern-note-card {\n  background-color: #fff;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  height: 100%;\n}\n.notes-grid-layout .modern-note-card .card-header-strip {\n  background-color: #f8fafb;\n  padding: 12px 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid #e2e8f0;\n  transition: background 0.3s ease;\n  gap: 10px;\n}\n.notes-grid-layout .modern-note-card .card-header-strip .header-left {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n.notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge {\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--primary-color);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.4;\n}\n.notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge .type-icon {\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n.notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge .title-text {\n  word-break: break-word;\n}\n.notes-grid-layout .modern-note-card .card-header-strip .header-actions {\n  display: flex;\n  gap: 6px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n.notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn.edit-btn:hover {\n  background: var(--container-bg);\n  opacity: 0.9;\n}\n.notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn.delete-btn:hover {\n  background: var(--container-bg);\n  opacity: 0.9;\n}\n.notes-grid-layout .modern-note-card .card-content-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n}\n.notes-grid-layout .modern-note-card .card-content-body .detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #6b7280;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-label .row-icon {\n  font-size: 0.9rem;\n  color: #9ca3af;\n}\n.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value {\n  font-size: 0.9rem;\n  color: #1f2937;\n  font-weight: 500;\n  padding-left: 2px;\n  line-height: 1.5;\n  word-break: break-word;\n}\n.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text {\n  color: #4b5563;\n  max-height: 150px;\n  overflow-y: auto;\n  padding-right: 4px;\n  /* Custom scrollbar */\n}\n.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar {\n  width: 3px;\n}\n.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar-thumb {\n  background-color: #d1d5db;\n  border-radius: 4px;\n}\n.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text .read-more-btn {\n  background: none;\n  border: none;\n  color: var(--primary-color);\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.8rem;\n  margin-left: 5px;\n  padding: 0;\n}\n.notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text .read-more-btn:hover {\n  text-decoration: underline;\n  color: var(--primary-color);\n}\n\n@media (max-width: 480px) {\n  .notes-grid-layout {\n    grid-template-columns: 1fr;\n  }\n  .notes-grid-layout .modern-note-card .card-header-strip {\n    padding: 10px;\n  }\n}\n/* --- Modern Tasks Grid View Styles --- */\n.tasks-grid-layout {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  padding: 10px 2px;\n}\n.tasks-grid-layout .modern-task-card {\n  background-color: #fff;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  height: 100%;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip {\n  background-color: #f8fafb;\n  padding: 12px 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid #e2e8f0;\n  transition: background 0.3s ease;\n  gap: 10px;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-left {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge {\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--primary-color);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.4;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge .type-icon {\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge .title-text {\n  word-break: break-word;\n  color: var(--primary-color);\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill {\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill.new {\n  background-color: #dcfce7;\n  color: #166534;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill.updated {\n  background-color: #e0f2fe;\n  color: #075985;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-actions {\n  display: flex;\n  gap: 6px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn.edit-btn:hover {\n  background: var(--container-bg);\n  opacity: 0.9;\n}\n.tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn.delete-btn:hover {\n  background: var(--container-bg);\n  opacity: 0.9;\n}\n.tasks-grid-layout .modern-task-card .card-content-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .recurring-info {\n  background-color: #fff7ed;\n  color: #c2410c;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px dashed #fdba74;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #6b7280;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-label .row-icon {\n  font-size: 0.9rem;\n  color: #9ca3af;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value {\n  font-size: 0.9rem;\n  color: #1f2937;\n  font-weight: 500;\n  padding-left: 2px;\n  line-height: 1.5;\n  word-break: break-word;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge.completed {\n  background-color: #d1fae5;\n  color: #047857;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge.pending {\n  background-color: #fee2e2;\n  color: #b91c1c;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text {\n  color: #4b5563;\n  max-height: 150px;\n  overflow-y: auto;\n  padding-right: 4px;\n  /* Custom scrollbar */\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar {\n  width: 3px;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar-thumb {\n  background-color: #d1d5db;\n  border-radius: 4px;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text .read-more-btn {\n  background: none;\n  border: none;\n  color: var(--primary-color);\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.8rem;\n  margin-left: 5px;\n  padding: 0;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text .read-more-btn:hover {\n  text-decoration: underline;\n  color: var(--primary-color);\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text img {\n  max-width: 100%;\n  height: auto;\n}\n.tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text p {\n  margin: 0 0 4px 0;\n}\n\n.task-badge-inline {\n  padding: 1px 5px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.task-badge-inline::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.task-badge-inline.new {\n  background-color: darkgreen;\n}\n.task-badge-inline.updated {\n  background-color: darkcyan;\n}\n\n.detail-row-horizontal {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n.detail-row-horizontal .detail-row-half {\n  flex: 1;\n  min-width: 0;\n}\n@media (max-width: 480px) {\n  .detail-row-horizontal {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 600px) {\n  .header-actions-container {\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n  .header-actions-container .actions-right {\n    margin-left: 0;\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n@media (max-width: 1024px) {\n  .tab-content {\n    max-height: 50vh;\n  }\n  .order-card,\n  .order-card-doc {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  .order-card .doc-content-wrapper,\n  .order-card-doc .doc-content-wrapper {\n    flex-direction: column;\n    width: 100%;\n  }\n  .order-card .doc-content-wrapper .customer-doc-actions,\n  .order-card-doc .doc-content-wrapper .customer-doc-actions {\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n  }\n  .order-card .order-det-card,\n  .order-card-doc .order-det-card {\n    width: 100%;\n    flex-direction: column;\n  }\n  .order-card .order-det-card .ord-det-card1,\n  .order-card .order-det-card .ord-det-card2,\n  .order-card-doc .order-det-card .ord-det-card1,\n  .order-card-doc .order-det-card .ord-det-card2 {\n    width: 100%;\n  }\n  .order-card .note-div-detail,\n  .order-card .order-expense-card,\n  .order-card .task-div-detail,\n  .order-card .doc-div-detail,\n  .order-card-doc .note-div-detail,\n  .order-card-doc .order-expense-card,\n  .order-card-doc .task-div-detail,\n  .order-card-doc .doc-div-detail {\n    width: 100%;\n    flex-direction: column;\n  }\n  .order-card .note-div-detail div,\n  .order-card .order-expense-card div,\n  .order-card .task-div-detail div,\n  .order-card .doc-div-detail div,\n  .order-card-doc .note-div-detail div,\n  .order-card-doc .order-expense-card div,\n  .order-card-doc .task-div-detail div,\n  .order-card-doc .doc-div-detail div {\n    width: 100%;\n  }\n  .order-card .editdel,\n  .order-card-doc .editdel {\n    justify-content: flex-start;\n  }\n  .tab-buttons-with-info {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  .tab-buttons-with-info .tab-buttons {\n    justify-content: flex-start;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n  .tab-buttons-with-info .tab-buttons button {\n    flex-shrink: 0;\n  }\n  .tab-buttons-with-info .tab-info-container {\n    margin-left: 0;\n    padding-left: 0;\n    align-self: flex-end;\n  }\n  .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {\n    width: 280px;\n    right: -10px;\n  }\n  .tab-header .info-button .info-tooltip {\n    width: 250px;\n    right: -10px;\n  }\n}\n@media (max-width: 768px) {\n  .tab-container {\n    padding: 16px;\n  }\n  .tab-container .tab-buttons-with-info .tab-buttons {\n    gap: 6px;\n  }\n  .tab-container .tab-buttons-with-info .tab-buttons button {\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container {\n    padding-left: 12px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container .info-button {\n    width: 26px;\n    height: 26px;\n    font-size: 13px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {\n    width: 250px;\n    right: -20px;\n    font-size: 12px;\n  }\n  .tab-content {\n    gap: 12px;\n    padding-right: 4px;\n  }\n  .order-card,\n  .order-card-doc {\n    padding: 16px;\n  }\n  .order-card p,\n  .order-card-doc p {\n    font-size: 14px;\n  }\n  .order-card .editdel > button,\n  .order-card-doc .editdel > button {\n    width: auto;\n    padding: 6px 12px;\n  }\n  .simple-item {\n    font-size: 13px;\n  }\n  .timeline-container {\n    margin: 12px;\n  }\n  .timeline-container .timeline-dot {\n    width: 12px;\n    height: 12px;\n  }\n  .timeline-container .tooltip {\n    min-width: 280px;\n    font-size: 13px;\n  }\n  .modal {\n    max-width: 95vw !important;\n  }\n  .tab-header .info-button .info-tooltip {\n    width: 220px;\n    right: -20px;\n    font-size: 12px;\n  }\n}\n@media (max-width: 480px) {\n  .tab-container .tab-buttons-with-info .tab-buttons {\n    gap: 4px;\n  }\n  .tab-container .tab-buttons-with-info .tab-buttons button {\n    font-size: 12px;\n    padding: 5px 10px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container {\n    padding-left: 8px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container .info-button {\n    width: 24px;\n    height: 24px;\n    font-size: 12px;\n    border-width: 1px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {\n    width: 220px;\n    right: -30px;\n    font-size: 11px;\n    padding: 10px 12px;\n  }\n  .order-card {\n    align-items: flex-start !important;\n  }\n  .order-card .note-div-detail,\n  .order-card .order-expense-card,\n  .order-card .task-div-detail {\n    display: block !important;\n    justify-content: space-between !important;\n    width: 100% !important;\n  }\n  .order-card .note-div-detail div,\n  .order-card .order-expense-card div,\n  .order-card .task-div-detail div {\n    width: 100% !important;\n  }\n  .order-card,\n  .order-card-doc {\n    padding: 12px;\n  }\n  .order-card p,\n  .order-card-doc p {\n    font-size: 13px;\n  }\n  .order-card .editdel,\n  .order-card-doc .editdel {\n    align-items: flex-start;\n    gap: 6px;\n  }\n  .order-card .editdel > button,\n  .order-card-doc .editdel > button {\n    width: 100%;\n  }\n  .modal {\n    padding: 0.5rem;\n  }\n  .modal .modal-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n  .modal .modal-actions button {\n    width: 100%;\n  }\n  .modal .task-tab-switcher {\n    flex-direction: column;\n  }\n  .modal .task-tab-switcher .task-tab-btn {\n    width: 100%;\n  }\n  .modal .assigned-due {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  .tooltip {\n    min-width: 90vw;\n    padding: 10px;\n  }\n  .tab-header .info-button {\n    width: 20px;\n    height: 20px;\n    font-size: 12px;\n  }\n  .tab-header .info-button .info-tooltip {\n    width: 200px;\n    right: -30px;\n    font-size: 11px;\n    padding: 10px 12px;\n  }\n}\n.custom-columns-content {\n  padding: 24px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n.custom-columns-content .custom-columns-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 20px;\n}\n.custom-columns-content .custom-columns-form .custom-column-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.custom-columns-content .custom-columns-form .custom-column-field label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #334155;\n  text-transform: capitalize;\n}\n.custom-columns-content .custom-columns-form .custom-column-field .custom-column-input {\n  padding: 10px 14px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #1e293b;\n  transition: all 0.2s;\n}\n.custom-columns-content .custom-columns-form .custom-column-field .custom-column-input:focus {\n  outline: none;\n  border-color: #004A9A;\n  box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);\n}\n.custom-columns-content .custom-columns-form .custom-column-field .custom-column-input::placeholder {\n  color: #94a3b8;\n}\n.custom-columns-content .custom-columns-form .custom-column-field .column-type {\n  font-size: 12px;\n  color: #64748b;\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .custom-columns-content {\n    padding: 16px;\n  }\n  .custom-columns-content .custom-columns-form {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
